import "../styles/layout.css";
import { useEmbeddedView } from "../hooks/useEmbeddedView";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  const embedded = useEmbeddedView();

  return (
    <div id="wrapper">
      <Header embedded={embedded} />
      <main role="main" className="container-lg">
        <div className="main-padding">{children}</div>
      </main>
      {!embedded && <Footer />}
    </div>
  );
}
